import { useState, useEffect } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import user from '../assets/user.png';
import styled from 'styled-components';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { registerValidate } from '../Helpers/validate';
import { registerUser } from '../Helpers/helper';
import { Button } from '../styles/Button';
import PasswordInput from './PasswordInput';
import { Toaster } from 'react-hot-toast';

function Register() {
  const navigate=useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(user);
  const [imageUrl, setImageUrl] = useState('');

  const onUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const formik = useFormik({
    initialValues: {
      email: '',
      username: '',
      password: ''
    },
    validate: registerValidate,
    validateOnBlur: false,
    validateOnChange: false,

    onSubmit: async (values) => {
      try {
        const errors = registerValidate(values);
        if (Object.keys(errors).length > 0) {
          if (errors.email) toast.error(errors.email);
          if (errors.username) toast.error(errors.username);
          if (errors.password) toast.error(errors.password);
          return; // stop submission if errors exist
        }
        // Step 1: Upload image if selected
        let uploadedImageUrl = '';
        if (selectedFile) {
          const formData = new FormData();
          formData.append('profile', selectedFile);

          const uploadRes = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/upload`, {
            method: 'POST',
            body: formData
          });

          if (!uploadRes.ok) {
            throw new Error('Image upload failed');
          }

          const uploadData = await uploadRes.json();
          uploadedImageUrl = uploadData.imageUrl;
        }

        // Step 2: Submit registration with imageUrl
        values = Object.assign(values, {
          profile: uploadedImageUrl || ''
        });

        const registerPromise = registerUser(values);
        
        toast.promise(registerPromise, {
          loading: 'Creating...',
          success: <b>Registered Successfully</b>,
          error: <b>Could not register</b>
        });

      registerPromise.then(() => {
      toast.success("Now you may login");   
      navigate("/username");               
    });
  } catch (error) {
    toast.error(error.message || 'Something went wrong');
      }
     
    }
    
  });

  
return (
  <Wrapper>    
      <Toaster position="top-center" reverseOrder={false} />  
      <div className="user-container">
        <div className="header-container">
          <h4 className="greeting">Register</h4>
          <span className="userspan">Happy to join you</span>
        </div>
        <hr />
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <label htmlFor="profile">
            <img className="user-img" src={previewUrl} alt="user-img" />
          </label>
            <input type="file" 
              id="profile" 
              name="profile" 
              onChange={onUpload} 
            />

          <div className="form-container">
            <input
              {...formik.getFieldProps('email')}
              type="email"
              className="email"
              placeholder="Email"
            />
            <input
              type="text"
              className="username"
              placeholder="Username"
              value={formik.values.username}
              onChange={(e) =>
                formik.setFieldValue('username', e.target.value.toUpperCase())
              }
              style={{ textTransform: "uppercase" }}
            />
            <PasswordInput
              {...formik.getFieldProps('password')}
              type="password"
              className="password"
              placeholder="Password"
            />
              <Button type="submit">
                Register
              </Button>
          </div>
        </form>
        <hr />
        <p className="user-para">
          Already Registered?{' '}
          <span className="linkspan">
            <Link to="/username">Login</Link>
          </span>
        </p>
      </div>
</Wrapper>
  );
}

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items:center;
  margin: 3rem;
 
  .user-container {
    width: 25%;
    padding:3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    background-color:${({ theme }) => theme.colors.bg};
    box-shadow:2px 2px 2px 4px #dfdfdf;
    }

  .header-container {
    display: flex;
    flex-direction: column; 
    align-items: center;
    }

  .greeting {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    margin: 0.5rem 0;
    }

  .userspan {
    font-size: 15px;
    text-align: center;
    padding: 0.5rem;
    color: blue;
    }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    }

  .user-img {
    width: 9rem;
    height: 9rem;
    margin: 0.5rem 0;
    padding: 0.4rem;
    border: 1px solid white;
    border-radius: 50%;
    box-shadow: 1px 1px 1px 1px #dfdfdf;    
    object-fit: cover;
  }

  .form-container {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding : 1rem;
    width: 100%;
  }

  hr {
    margin-top: 1.2rem;
    width: 100%;
    border: 1px solid black;
  }

  .user-para {
    text-align: center;
    font-size: 1.5rem;
    margin-top: 1rem;
  }

  .linkspan {
    color: black;
    font-weight: bold;
  }

  
  input[type='file'] {
    display: none;
  }
@media (max-width: ${({ theme }) => theme.media.mobile}) {
 .user-container {    
    padding: 1rem;
    width : 100%
  }

}

`;

export default Register;
